<template>
    <c-dialog ref="dialog" title="收款账号管理" width="700" height="480" :button="false">
        <div class="account-manage">
            <div class="toolbar">
                <c-button color="main" prepend-icon="tf-add" @click="editHandle()">新建</c-button>
            </div>
            <c-table ref="accountList" height="grow" :paging="{ size: 10 }">
                <c-table-column label="收款人" name="account_name" width="100"></c-table-column>
                <c-table-column label="银行卡号" name="card_no" width="200"></c-table-column>
                <c-table-column label="开卡行及支行" name="bank_name" width="260"></c-table-column>
                <c-table-column type="button" label="操作" width="100">
                    <template #default="{data}">
                        <c-table-button @click="editHandle(data)">编辑</c-table-button>
                        <c-table-button @click="deleteHandle(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </div>
        <c-dialog ref="editor">
            <c-form ref="editForm">
                <c-form-item label="收款人" required>
                    <c-input type="hidden" name="id"></c-input>
                    <c-input name="account_name"></c-input>
                </c-form-item>
                <c-form-item label="开卡行及支行" required>
                    <c-input name="bank_name"></c-input>
                </c-form-item>
                <c-form-item label="银行卡号" required>
                    <c-input name="card_no"></c-input>
                </c-form-item>
            </c-form>
        </c-dialog>
    </c-dialog>
</template>

<script>
export default {
    name: 'accountSelector',
    methods: {
        open() {
            this.$refs.dialog.open();
            this.$nextTick(() => {
                this.searchHandle();
            });
        },

        searchHandle() {
            this.$refs.accountList.load({
                url: '/sys_user/bank_account/list',
                data: {pageIndex: 1, pageSize: 10}
            });
        },

        editHandle(item) {
            this.$refs.editForm.clear();
            this.$refs.editForm.set(item);
            this.$refs.editor.open({
                title: item ? '编辑收款账号' : '新建收款账号',
                resolve: (stop, next) => {
                    stop();
                    this.$refs.editForm.submit({
                        url: item ? '/sys_user/bank_account/edit' : '/sys_user/bank_account/add',
                        rule: {
                            account_name: '请填写收款人',
                            bank_name: '请填写开卡行及支行',
                            card_no: '请填写银行卡号'
                        },
                        success: () => {
                            next();
                            this.$message({message: '保存成功', type: 'success'});
                            this.searchHandle();
                            this.$emit('refresh');
                        }
                    });
                }
            });
        },

        deleteHandle(item) {
            this.$confirm({
                message: '确定要删除该账号吗',
                resolve: () => {
                    this.request({
                        url: '/sys_user/bank_account/delete',
                        data: {id: item.id},
                        loading: true,
                        success: () => {
                            this.$message({message: '删除成功', type: 'success'});
                            this.searchHandle();
                            this.$emit('refresh');
                        }
                    });
                }
            });
        }
    }
};
</script>

<style lang="stylus" scoped>
.account-manage {
    display: flex;
    flex-direction: column;
    height: 100%;
}
.toolbar {
    padding: 6px 10px;
}
</style>
